import {
  Component,
  EventEmitter,
  h,
  Prop,
  Event,
  Element,
  State,
  Method,
  ComponentInterface,
  Watch
} from '@stencil/core';
import { JuiControlSize } from '../../../shared/form-controls/jui-form-control.model';

@Component({
  tag: 'jui-radio',
  styleUrl: 'jui-radio.scss',
  shadow: true,
  formAssociated: true
})
export class JuiRadio implements ComponentInterface {
  /**
   * Label to display for the radio input.
   */
  @Prop() label = '';

  /**
   * Value to hold the current value for the radio.
   */
  @Prop({ attribute: 'value', reflect: true, mutable: true }) value = '';

  /**
   * The form name the radio input belongs to.
   */
  @Prop() name = '';

  /**
   * Marking the input field as disabled. Defaults to false
   */
  @Prop() disable: boolean;

  /**
   * Set the size of the checkbox. Defaults to md.
   */
  @Prop() size: JuiControlSize = JuiControlSize.md;

  /**
   * Set the radio input as checked. Defaults to false.
   */

  @Prop({ attribute: 'checked', reflect: true })
  checked = false;

  @Watch('checked')
  checkedChanged(checked: any | undefined) {
    if (checked) {
      this.juiChecked.emit(this.value);
    }
  }

  /**
   * The tabindex of the radio button.
   * @internal
   */
  @State() buttonTabindex = -1;

  @Event() public juiChecked: EventEmitter<string>;

  @Element() el: HTMLElement;

  @Method()
  async setButtonTabindex(value: number) {
    this.buttonTabindex = value;
  }

  @Method()
  async setFocused() {
    (this.el.shadowRoot.querySelector('.jui-radio__input') as HTMLInputElement).focus();
  }

  render() {
    return (
      <div class={{ 'jui-radio': true, [`jui-radio--flex`]: !!this.label }}>
        <input
          role="radio"
          type="radio"
          class={{
            'jui-radio__input': true,
            [`jui-radio__input--${this.size}`]: true
          }}
          name={this.name}
          disabled={this.disable}
          checked={this.checked}
          id={this.label}
          value={this.value}
          onChange={() => this.onClick()}
          tabindex={this.buttonTabindex}
        ></input>
        <label
          htmlFor={this.label}
          class={{
            'jui-radio__label': true,
            [`jui-radio__label--${this.size}`]: true,
            [`jui-radio__label--disabled`]: !!this.disable
          }}
        >
          {this.label}
        </label>
      </div>
    );
  }

  private onClick(): void {
    this.checked = true;
    this.juiChecked.emit(this.value);
  }

  componentWillLoad(): void {
    if (!this.value) {
      this.value = this.label;
    }
  }
}
